
import { defineComponent, ref, onMounted, reactive } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useI18n } from "vue-i18n";
import * as Yup from "yup";
import mAxiosApi from "@/api";

export default defineComponent({
  name: "sign-in",
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  setup() {
    const store = useStore();
    const router = useRouter();

    const state = reactive({
      username: "",
      password: "",
      displayLogin : false,
    });
    const { t } = useI18n()

    //let username = "";
    //let password = "";

    const submitButton = ref<HTMLElement | null>(null);

    const formLogin = ref<HTMLFormElement | null>(null);

    //Create form validation object
    const login = Yup.object().shape({
      username: Yup.string()
        .email(t("L'identifiant doit être un email valide"))
        .required(t("L'identifiant est obligatoire"))
        .label("username"),
      password: Yup.string()
        .required(t("Le mot de passe est obligatoire"))
        .label("Password"),
    });



    //Form submit function
    const onSubmitLogin = (values) => {
      // Clear existing errors
      store.dispatch(Actions.LOGOUT);

      if (submitButton.value) {
        // Activate indicator
        submitButton.value.setAttribute("data-kt-indicator", "on");
      }

      // Dummy delay
      setTimeout(() => {
        // Send login request
        store
          .dispatch(Actions.LOGIN, values)
          .then(() => {
            mAxiosApi.prototype.getAxios("/logLogin")
            if (router.currentRoute.value.params.loginpassword) {
              if (router.currentRoute.value.params.redirect) {
                const stringRec = (router.currentRoute.value.params.redirect) as string;
                router.push({ name: stringRec });
              } else {
                router.push({ name: "stillboard" });  //stillboard
              }
              return true;
            }
            Swal.fire({
              title: t("Connexion établie !"),
              text:
                t("Bienvenue")+ " " +
                store.getters.currentUser.con_prenom +
                " " +
                store.getters.currentUser.con_nom +
                " " + t("sur votre board StillOnline !"),
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: t("Accèder à StillOnline"),
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            }).then(function () {
              
              if (router.currentRoute.value.params.redirect) {
                const stringRec = (router.currentRoute.value.params.redirect) as string;
                router.push({ name: stringRec });
              } else {
                if (store.getters.currentUser.con_redirect_auto) {
                  router.push({ name: store.getters.currentUser.con_redirect_auto });  //stillboard 
                }else {
                  router.push({ name: "stillboard" });  //stillboard 
                }
                

              }

            });


          })
          .catch(() => {
            Swal.fire({
              text: t("Il semble y avoir une erreur, veuillez vérifier vous identifiants de connexion."),
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: t("Retourner sur la page de connexion"),
              customClass: {
                confirmButton: "btn fw-bold btn-light-danger",
              },
            });
          });

        //Deactivate indicator
        submitButton.value?.removeAttribute("data-kt-indicator");
      }, 500);
    };



    onMounted(() => {
      localStorage.removeItem('storedConst');
      if (store.getters.isUserAuthenticated){
        if (router.currentRoute.value.params.redirect) {
          const stringRec = (router.currentRoute.value.params.redirect) as string;
          router.push({ name: stringRec });
          return false;
        } 
      }

      state.displayLogin = true;

      if (router.currentRoute.value.params.loginpassword) {
        store.dispatch(Actions.LOGOUT);
        const stringRec = (router.currentRoute.value.params.loginpassword) as string;
        state.username = window.atob(stringRec).split("|$|")[0];
        state.password = window.atob(stringRec).split("|$|")[1];
        
        if (submitButton.value) submitButton.value.click();
      }
    });      

    return {
      onSubmitLogin,
      login,
      submitButton,
      state,
      formLogin,
    };
  },
});
